<template>
    <similiarity-alert-base
        v-if="isPassed === true"
        type="success"
        dense
        class="mb-0 ml-2"
    >
        Tidak ada soal sama
    </similiarity-alert-base>
    <similiarity-alert-base
        v-else-if="isPassed === false"
        type="warning"
        dense
        class="mb-0 ml-2"
    >
        Ada soal sama
    </similiarity-alert-base>
</template>

<script>
import SimiliarityAlertBase from './SimiliarityAlertBase.vue'

export default {
    props: ['isPassed'],

    components: {
        SimiliarityAlertBase
    }
}
</script>
